<template>
  <div class="bc-crop" role="dialog" aria-modal="true" aria-label="Ajustar imagem">
    <div class="bc-crop__panel">
      <h5 class="bc-crop__title">Ajustar imagem</h5>
      <cropper ref="cropper" class="bc-crop__area" :src="src"
               :stencil-props="{ aspectRatio: aspect }" image-restriction="none"/>
      <p class="bc-crop__hint">Arraste e use a roda do mouse para enquadrar. O banner mostra exatamente esta área.</p>
      <p class="bc-crop__error" v-if="error">{{ error }}</p>
      <div class="bc-crop__actions">
        <span class="bc-crop__btn" role="button" tabindex="0" @click="$emit('cancel')">Cancelar</span>
        <span class="bc-crop__btn bc-crop__btn--primary" role="button" tabindex="0" @click="confirm">
          {{ busy ? 'Recortando…' : 'Aplicar' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import { BANNER_CROP, cropToFile } from './bannerCrop';

/**
 * "Ajustar imagem" do banner: mesmo comportamento da tela de personalizacao
 * do V2 (modalCropImage.tsx), proporcao travada no tamanho do banner.
 */
export default {
  name: 'modal-crop-banner',
  components: { Cropper },
  props: {
    file: { type: File, required: true },
  },
  data() {
    return { src: URL.createObjectURL(this.file), busy: false, error: '', aspect: BANNER_CROP.width / BANNER_CROP.height };
  },
  beforeDestroy() {
    URL.revokeObjectURL(this.src);
  },
  methods: {
    confirm() {
      if (this.busy) return;
      const { coordinates } = this.$refs.cropper.getResult();
      if (!coordinates) {
        this.error = 'Não foi possível recortar a imagem. Tente outra.';
        return;
      }
      this.busy = true;
      this.error = '';
      cropToFile(this.src, coordinates, this.file.name)
        .then((file) => this.$emit('done', file))
        .catch(() => { this.error = 'Não foi possível recortar a imagem. Tente outra.'; })
        .then(() => { this.busy = false; });
    },
  },
};
</script>

<style scoped>
.bc-crop { position: fixed; inset: 0; z-index: 1050; display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, .45); padding: 16px; }
.bc-crop__panel { width: 560px; max-width: 100%; max-height: 90vh; display: flex; flex-direction: column; gap: 12px; padding: 20px; background: #fff; border-radius: 12px; }
.bc-crop__title { margin: 0; font-size: 16px; font-weight: 600; color: #3a424e; }
.bc-crop__area { height: 320px; background: #1e1e1e; }
.bc-crop__hint { margin: 0; font-size: 12px; color: #4e5560; }
.bc-crop__error { margin: 0; font-size: 12px; color: #e74a4e; }
.bc-crop__actions { display: flex; justify-content: flex-end; gap: 8px; }
.bc-crop__btn { padding: 8px 16px; border-radius: 6px; border: 1px solid #d5d7da; cursor: pointer; font-size: 14px; }
.bc-crop__btn--primary { background: #1b59f8; border-color: #1b59f8; color: #fff; }
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/broadcast/modalCropBanner.vue